<div class="col-md-12 job-footer">
  <p [innerHtml]="theme.disclaimerContent"></p>
  <p><a href="https://keldairhr.com/privacy/" target="_blank">Privacy Policy</a></p>
</div>